import _ from 'lodash';
import { createApp, defineComponent } from 'vue';
import GridDateCellEditor from './GridDateCellEditor.vue';
import dateFormatHelper from '$$dateFormatsHelper';
import globalToast from '$$vueCmp/toast';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridDateCellEditor);
      const task = instance.getTask(id);

      const calendar = instance.getCalendar(task.gantt_id);
      const calendarConfig = _.cloneDeep(calendar.getConfig());

      const workDays = instance.config.durationData.showDay;
      const dateToStr = instance.date.date_to_str;

      const minDate = column.name === 'end_date' ? task.start_date : null;
      let todayDate = null;

      if ((minDate ? minDate < new Date() : true) && instance.isWorkDay(new Date(), calendar)) {
        todayDate = column.name === 'end_date' ? instance.date.day_start(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)) : instance.date.day_start(new Date());
      }

      const onSave = () => {
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        column,
        workDays,
        calendarConfig,
        minDate,
        todayDate,
        dateToStr,
        onSave,
        onCancel,
      });
      vueInstance = vueApp.mount(placeholder);

      KeyboardNavigation.toggleState(false);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;

      KeyboardNavigation.toggleState(true);
    },

    set_value(task, id, column, node) {
      vueInstance.value = task[column.name];
    },

    get_value(id, column, node) {
      return vueInstance.corruptedInputValue || vueInstance.value;
    },

    is_changed(task, id, column, node) {
      const vueValue = vueInstance.corruptedInputValue || vueInstance.value?.valueOf();
      return task[column.name].valueOf() !== vueValue;
    },

    is_valid(value, id, column, node) {
      if (!value || !(value instanceof Date) || (value instanceof Date && isNaN(value.getTime()))) {
        globalToast.warning(__('gantt_date_invalid'));

        return false;
      }

      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const calendar = instance.getCalendar(task.gantt_id);
      const value = dateFormatHelper.checkIfDateInLimit(vueInstance.value, false);

      if (value && column.name === 'start_date') {
        let newValue = instance.date.minute_start(value);

        if (!instance.isWorkDay(newValue, calendar) || !instance.isWorkTime(newValue, 'minute', calendar)) {
          newValue = instance.getClosestWorkTime({
            date: newValue,
            dir: 'future',
            unit: instance.config.duration_unit,
            task,
          });
        }

        if (task.start_date.valueOf() !== newValue.valueOf()) {
          const oldDate = task.start_date;

          task.start_date = newValue;
          task.end_date = instance.calculateEndDate({
            start_date: task.start_date,
            duration: task.duration,
            unit: instance.config.duration_unit,
            task,
          });

          if (task.type === instance.config.types.project) {
            instance.moveProject(task.id, task.start_date, oldDate);
          }

          instance.updateTask(task.id);

          userExtAnalytics.log('task_grid_action', { action: 'start_date' });
        }
      }

      if (value && column.name === 'end_date') {
        const newValue = instance.date.minute_start(value);

        if (task.end_date.valueOf() !== newValue.valueOf() && task.start_date.valueOf() < newValue.valueOf()) {
          task.duration = instance.calculateDuration({
            start_date: task.start_date,
            end_date: newValue,
            unit: instance.config.duration_unit,
            task,
          });
          task.end_date = instance.calculateEndDate({
            start_date: task.start_date,
            duration: task.duration,
            unit: instance.config.duration_unit,
            task,
          });

          instance.updateTask(task.id);

          userExtAnalytics.log('task_grid_action', { action: 'end_date' });
        }
      }
    },

    focus(node) {
    },
  };
}
